import { Check, X } from "lucide-react";
import type { ValueTypeEntry } from "../index";
import { BooleanEditor, type BooleanValue } from "./boolean-editor";

/**
 * Built-in `boolean` field type. Format emits "Yes"/"No"/"". Render
 * emits a green check for true, a muted X for false, and null for null.
 * The editor renders two toggle buttons; clicking commits immediately,
 * Escape cancels.
 */
export const booleanType: ValueTypeEntry<BooleanValue> = {
  name: "boolean",
  format(value) {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return "";
  },
  render({ value }) {
    if (value === true) return <Check className="size-4 text-emerald-600" aria-label="Yes" />;
    if (value === false) return <X className="size-4 text-muted-foreground" aria-label="No" />;
    return null;
  },
  display({ value }) {
    const narrowed = typeof value === "boolean" ? value : null;
    if (narrowed === true) return <Check className="size-4 text-emerald-600" aria-label="Yes" />;
    if (narrowed === false) return <X className="size-4 text-muted-foreground" aria-label="No" />;
    return null;
  },
  edit({ value, onCommit, onCancel }) {
    return <BooleanEditor value={value} onCommit={onCommit} onCancel={onCancel} />;
  },
};
